module.exports = __webpack_public_path__ + "img/IMG_2385_1.00dce656.webp";